<template>
    <div class="col-lg-10 col-md-12 offset-lg-1">
        <div class="row align-items-center">
            <div class="col-12 col-lg-6 col-md-6">
                <div class="meetParner-image-container">
                    <img class="lazy" :data-src="image_url" alt="">
                </div>
            </div>
            <div class="col-12 col-lg-6 col-md-6" v-html="body_content">
                
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
  data() {
    return {};
  },
  props: {
    body_content:{ type: String, default:'' },
    image_url: { type: String, default:'' }
  },
  methods: {},
};
</script>

  